import styled from '@emotion/styled';
import { FunctionComponent } from 'react';
import { Image } from '@ds/ui';
import OliveImages from '@olive/images';
import { inkSpacingTokens } from '@ds/tokens';

interface WarningIconProps {
  dataQa?: string;
}

const ImageContainer = styled.div`
    margin: ${inkSpacingTokens.spacingXS} 0;
    height: 80px;
    width: 80px;
`;

const WarningIcon: FunctionComponent<WarningIconProps> = ({ dataQa }) => (
    <ImageContainer>
        <Image src={OliveImages.idpWarning} data-qa={dataQa} alt='warning-icon'/>
    </ImageContainer>
);

export default WarningIcon;